import { IntegrationCode } from 'modules/data/domain';

import { integrationsWithDuplicateCheck } from './ActionsBlock.constants';

export const hasDuplicateCheck = (integrationCode?: IntegrationCode | null) => {
    if (!integrationCode || !integrationsWithDuplicateCheck.includes(integrationCode)) return false;

    return true;
};
